import workflowTaskMixins from "@/components/workflow/mixin/WorkflowTaskMixins";

export default {
    mixins: [workflowTaskMixins],
    computed: {
        config() {
            return {
                'task1': {
                    name: '需求部门主管审批',
                    approveLabel: '是否同意',
                    variables: [
                        {
                            label: '备注',
                            name: 'remark',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.DATABASE
                        }
                    ],
                    setApproveByBusinessData: (businessData, approve) => {
                        // 同意且是内对外(transType=1)，且是外协框架外(fram=2)，则走给采购处理。不走给采购了只通知采购(20211222)
                        // if (businessData.transType === 1 && approve === 1 && businessData.frame === 2) {
                        //     return 3;
                        // }
                        // 同意、内对外，外协框架内，则走给运输操作员
                        // if(businessData.transType === 1 && approve === 1 && businessData.frame === 1) {
                        //     return 3;
                        // }
                        // 同意且是内对内，则走给运输操作员处理
                        // if (businessData.transType > 1 && approve === 1) {
                        //     return 3;
                        // }
                        if (approve === 1) {
                            return 3;
                        }
                        return approve;
                    },
                    postByApprove: (approve) => {
                        // return {
                        //     url: process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryTransportApplication/task1/setApprover",
                        //     data: {
                        //         id: this.$_emWorkflowTaskMixin_businessKey,
                        //     }
                        // };
                        return {
                            url: process.env.VUE_APP_SITHMES_INVENTORY_URL + `/sithMesInventoryTransportApplication/doAfterManagerApprove?applicationId=${this.$_emWorkflowTaskMixin_businessKey}&approvedStatus=${approve}`,
                            data: {}
                        };
                    },
                    userSelectMap: {
                        '1': [
                            {
                                name: 'task2_candidates',
                                allowMulti: true,
                                require: true
                            }
                        ],
                        '3': [
                            {
                                name: 'task3_candidates',
                                allowMulti: true,
                                require: true
                            }
                        ]
                    },
                    approveToNextTask: {
                        1: 'task2',
                        2: 'reject',
                        3: 'task3'
                    }
                },
                'task2': {
                    name: '采购处理',
                    variables: [
                        {
                            label: '是否同意',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '同意'},
                                {value: 2, text: '不同意'}
                            ],
                        },
                        {
                            needTag: 'trans',
                            label: '转出地址',
                            name: 'sourceAddr',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true
                        },
                        {
                            needTag: 'trans',
                            label: '转出方联系人',
                            name: 'sourceContact',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true
                        },
                        {
                            needTag: 'trans',
                            label: '转出方电话',
                            name: 'sourcePhone',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true
                        },
                        {
                            label: '备注',
                            name: 'remark',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.DATABASE
                        }
                    ],
                    changeTag: (businessData, approve) => {
                        // 采购同意，且是框架外时才输入运输信息
                        return this.buildTag('trans', businessData.frame === 2 && approve === 1);
                    },
                    postByApprove: () => {
                        return {
                            url: process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryTransportApplication/task2/setApprover",
                            data: {
                                id: this.$_emWorkflowTaskMixin_businessKey,
                            }
                        };
                    },
                    userSelectMap: {
                        '1': [
                            {
                                name: 'task3_candidates',
                                allowMulti: true,
                                require: true
                            }
                        ]
                    },
                    approveToNextTask: {
                        1: 'task3',
                        2: 'task1',
                    }
                },
                'task3': {
                    name: '运输操作员处理',
                    approveLabel: '是否同意',
                    variables: [
                        {
                            label: '备注',
                            name: 'remark',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.DATABASE
                        }
                    ],
                    setApproveByBusinessData: (businessData, approve) => {
                        // 驳回且是内对内，则返回给需求部门主管
                        if (businessData.transType === 2 && approve === 2) {
                            return 2;
                        }
                        // 驳回且是内对外，则返回给采购处理(采购步骤已取消)
                        if (businessData.transType === 1 && approve === 2) {
                            return 2;
                        }
                        // 外对外，跳过实物操作员给物流经理
                        if (businessData.transType === 4 && approve === 1) {
                            return 3;
                        }

                        return approve;
                    },
                    postByApprove: () => {
                        return {
                            url: process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryTransportApplication/task3/setApprover",
                            data: {
                                id: this.$_emWorkflowTaskMixin_businessKey,
                            },
                            needId: true
                        };
                    },
                    userSelectMap: {
                        '1': [
                            {
                                name: 'task4_candidates',
                                allowMulti: true,
                                require: true
                            }
                        ],
                        '3': [
                            {
                                name: 'task5_candidates',
                                allowMulti: false,
                                require: true
                            }
                        ]
                    },
                    approveToNextTask: {
                        1: 'task4',
                        2: 'task1',
                        3: 'task5'
                    }
                },
                'task4': {
                    name: '实物操作员处理',
                    variables: [
                        {
                            label: '是否同意',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '同意'},
                                {value: 2, text: '不同意'}
                            ],
                        },
                        {
                            needTag: 'car',
                            label: '运输开始时间',
                            name: 'transStartTime',
                            type: this.VALUE_TYPE.DATETIME,
                            saveTo: this.SAVE_TO.DATABASE,
                        },
                        {
                            needTag: 'car',
                            label: '运输完成时间',
                            name: 'transCompleteTime',
                            type: this.VALUE_TYPE.DATETIME,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true
                        },
                        {
                            needTag: 'car',
                            label: '车型',
                            name: 'vehicleType',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true
                        },
                        {
                            needTag: 'car',
                            label: '车牌号',
                            name: 'carNumber',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true
                        },
                        {
                            needTag: 'car',
                            label: '吨位',
                            name: 'tonnage',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true,
                        },
                        {
                            label: '备注',
                            name: 'remark',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.DATABASE
                        }
                    ],
                    changeTag: (businessData, approve) => {

                        return this.buildTag('car', approve === 1);
                    },
                    withAttachment: true,
                    postByApprove: () => {
                        return {
                            url: process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryTransportApplication/task4/setApprover",
                            data: {
                                id: this.$_emWorkflowTaskMixin_businessKey,
                            },
                            needId: true
                        };
                    },
                    userSelectMap: {
                        '1': [
                            {
                                name: 'task5_candidates',
                                allowMulti: false,
                                require: true
                            }
                        ]
                    },
                    approveToNextTask: {
                        1: 'task5',
                        2: 'task3'
                    }
                },
                'task5': {
                    name: '物流经理审批',
                    approveLabel: '是否同意',
                    withComment: true,
                    setApproveByBusinessData: (businessData, approve) => {
                        // 外对外，回退给运输操作员
                        if (businessData.transType === 4 && approve === 2) {
                            return 3;
                        }

                        return approve;
                    },
                    postByApprove: () => {
                        return {
                            url: process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryTransportApplication/task5/setApprover",
                            data: {
                                id: this.$_emWorkflowTaskMixin_businessKey,
                            },
                            needId: true
                        };
                    },
                    userSelectMap: {
                        '1': [
                            {
                                name: 'task6_candidates',
                                allowMulti: true,
                                require: true
                            }
                        ]
                    },
                    approveToNextTask: {
                        1: 'task6',
                        2: 'task4',
                        3: 'task3'
                    }
                },
                'task6': {
                    name: '物流运输管理员处理',
                    variables: [
                        {
                            label: '运输PR',
                            name: 'transPr',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true,
                            require: true,
                        },
                        {
                            label: '运输框架内/外',
                            name: 'transportFrame',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: [
                                {value: 1, text: '框架内'},
                                {value: 2, text: '框架外'}
                            ],
                            initData: true,
                            require: true,
                        },
                        {
                            label: '运输商',
                            name: 'transporter',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true,
                            require: true,
                        },
                        {
                            label: '备注',
                            name: 'remark',
                            type: this.VALUE_TYPE.TEXTAREA,
                            saveTo: this.SAVE_TO.DATABASE
                        }
                    ],
                    postByApprove: () => {
                        return {
                            url: process.env.VUE_APP_SITHMES_INVENTORY_URL + "/sithMesInventoryTransportApplication/task6/setApprover",
                            data: {
                                id: this.$_emWorkflowTaskMixin_businessKey,
                            }
                        };
                    },
                    approveToNextTask: 'task_end'
                },
                'task_end': {
                    name: '流程结束'
                },
                'reject': {
                    name: '流程结束'
                }
            }
        }
    }
}
